export const columnContextEn = {
  orderTasksBy: 'Order tasks by...'
}

export const columnContextRu = {
  orderTasksBy: 'Сортировать задачи по...'
}

export const columnCrmContextEn = {
  orderTasksBy: 'Order deals by...'
}

export const columnCrmContextRu = {
  orderTasksBy: 'Сортировать сделки по...'
}
